import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {HttpResponse} from '@angular/common/http';
import {Standard} from 'app/models/standard.model';
import {Blank} from 'app/models/blank.model';
import {StandardFileActions} from 'app/services/standard-file-actions';
import {standardResponseWithVersion} from 'app/services/standard-version';
import {NewBlank} from '../../../../models/new-blank.model';
import {PrefixService} from 'app/services/prefix.service';
import {ViewDocxService} from '../../../../services/view-docx.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {StandardTypesService} from '../../../../services/standard-types.service';
import {AdminService} from '../../../../services/admin.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {UserService} from '../../../../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-steps-blanks',
  templateUrl: './steps-blanks.component.html',
  styleUrls: ['./steps-blanks.component.css']
})

export class StepsBlanksComponent implements OnInit, OnDestroy {
  @Input() blocked = false;
  fileActions = new StandardFileActions(this.adminService, this.modalService);
  fileReloadFailed = false;
  fileReloadPending = false;
  private filesDestroyed$ = new Subject<void>();

  newBlanks: NewBlank[] = [];
  isLoaded = true;
  thisStandard: any;

  constructor(public prefixService: PrefixService,
              public viewDocxService: ViewDocxService,
              public stepsControllerService: StepsControllerService,
              public standardTypesService: StandardTypesService,
              private adminService: AdminService,
              private apiConnectService: ApiConnectService,
              private userService: UserService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    // Get standard
    if (this.stepsControllerService.getCurrentStandard()) {
      this.thisStandard = this.stepsControllerService.getCurrentStandard();

    } else {
      this.thisStandard = null;
    }
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  validationBlank(blank) {
    return blank.number !== null && blank.number.trim() !== '' &&
      blank.name !== null && blank.name.trim() !== '' &&
      blank.formData;
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    } else {
      this.newBlanks[index].formData = null;
    }
  }

  deleteBlank(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }


  deleteBlankFile(blank: Blank): void {
    if (this.blocked || this.fileReloadPending) { return; }
    this.fileActions.removeBlank(this.thisStandard, blank, () => {
      this.stepsControllerService.showByFilesAndBlanks = true;
    });
  }


  saveBlank(index: number): void {
    const draft = this.newBlanks[index];
    if (this.blocked || this.fileReloadPending || !draft || !this.validationBlank(draft)) { return; }
    this.fileActions.uploadBlanks(this.thisStandard, [draft], () => {
      this.newBlanks = this.newBlanks.filter(item => item !== draft);
      this.stepsControllerService.showByFilesAndBlanks = true;
    });
  }



  ngOnDestroy(): void {
    this.fileActions.ngOnDestroy();
    this.filesDestroyed$.next();
    this.filesDestroyed$.complete();
  }

  reloadStandardFiles(): void {
    if (this.blocked || this.fileActions.pending || this.fileReloadPending) { return; }
    this.fileReloadPending = true;
    this.fileReloadFailed = false;
    this.adminService.getStandard(this.thisStandard.id).takeUntil(this.filesDestroyed$).subscribe(
      (response: HttpResponse<Standard>) => {
        this.fileReloadPending = false;
        const standard = standardResponseWithVersion(response).body;
        if (!standard || standard.id !== this.thisStandard.id) { this.fileReloadFailed = true; return; }
        this.fileActions.reset();
        this.stepsControllerService.setCurrentStandard(standard);
      }, () => { this.fileReloadPending = false; this.fileReloadFailed = true; }
    );
  }}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/steps-blanks/steps-blanks.component.ts